import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=3c8dac00&"
import script from "./LogsTable.vue?vue&type=script&lang=ts&"
export * from "./LogsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports